import { useGateValue } from '@coursera-web/statsig';

// https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/gates/wes-coach-brand-update
export const useIsWesCoachBrandUpdateEnabled = () => {
  return useGateValue('wes-coach-brand-update');
};
